import { useState } from "react";
import Modal from "@mui/material/Modal";
import { Card, SubText } from "../styles";
import styled from "styled-components";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase/firebase";
import toast from "react-hot-toast";

const WithdrawalLimitModal = ({ open, user }) => {
  const { withdrawalLimit, setWithdrawalLimit } = open;
  const [isUpgrading, setIsUpgrading] = useState(false);
  const [account, setAccount] = useState("Starter");

  function handleAccount(e) {
    const value = e.target.value;

    if (value) {
      setAccount(value);
    } else {
      setAccount("");
    }
  }

  function handleUpgrade() {
    setIsUpgrading(true);
    handleChange(user.id);
  }

  async function handleChange(id) {
    const selected = doc(db, "users", id);
    await updateDoc(selected, {
      withdrawalMaxLimit: Number(account),
    })
      .then(() => {
        toast.success("Set Successfully");
        setIsUpgrading(false);
        setWithdrawalLimit(false);
      })
      .catch((error) => {
        toast.error(
          "There was a problem with your request.\n \n Please try again later."
        );
        setIsUpgrading(false);
      });
  }

  return (
    <Modal
      open={withdrawalLimit}
      onClose={() => setWithdrawalLimit(false)}
      style={{
        color: "white",
        placeContent: "center",
        display: "flex",
      }}
    >
      <Card
        style={{
          placeSelf: "center",
          maxWidth: "360px",
        }}
      >
        <div className="top">
          <SubText>Withdrawal Limit</SubText>
          <button
            // className="close"
            style={{
              backgroundColor: "transparent",
              border: "none",
              outline: "none",
            }}
            onClick={() => setWithdrawalLimit(false)}
          >
            <img
              src="/icons-sidebar/close.svg"
              alt="close"
              className="close"
              height={10}
              width={10}
            />
          </button>
        </div>
        <ModalContent>
          <div className="addcon">
            <label htmlFor="new">Client Name</label>
            <div className="add">
              <input
                //   ref={cryptoAddressRef}
                disabled
                placeholder={user?.firstname}
                defaultValue={user?.firstname}
                //   onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>

          {/* {user.tradingProgress && (
            <div className="addcon">
              <label htmlFor="new">Trading Progress</label>
              <div className="add">
                <input
                 onChange={handleAccount}
                //   disabled
                  placeholder={user.tradingProgress}
                //   defaultValue={user.tradingProgress}
                />
              </div>
            </div>
          )} */}

          <div className="addcon">
            <label htmlFor="new">Withdrawal Limit</label>
            <div className="add">
              <input
                //   ref={cryptoAddressRef}
                // disabled
                onChange={handleAccount}
                placeholder={user?.withdrawalMaxLimit}
                defaultValue={user?.withdrawalMaxLimit}
                //   onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>

          {/* <div className="selectWrap">
            <label htmlFor="type">New Trading Progress</label>
            <div className="selectBox">
              <div className="selectTop">
                <input
                  onChange={handleAccount}
                  placeholder={user.tradingProgress}
                  defaultValue={user.tradingProgress}
                />
                <img src="/icons-extra/arrowdown.svg" alt="select" />
              </div>
            </div>
          </div> */}
          <button
            className={!account ? "button disabled" : "button submit"}
            disabled={isUpgrading || !account}
            onClick={handleUpgrade}
          >
            {isUpgrading ? (
              <img
                src="/svg-loaders/tail-spin.svg"
                alt="loading"
                style={{
                  padding: "10px",
                  width: "20px",
                  height: "auto",
                }}
              />
            ) : (
              <p
                style={{
                  textDecoration: "none",
                  color: "white",
                  maxWidth: "max-content",
                  placeSelf: "center",
                }}
              >
                Change
              </p>
            )}
          </button>
        </ModalContent>
      </Card>
    </Modal>
  );
};

const ModalContent = styled.div`
  padding: 1.5rem 1.3rem;
  display: grid;
  gap: 1rem;

  .selectWrap {
    display: grid;
    gap: 0.5rem;

    label {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #a3a3a3;
    }

    .selectBox {
      display: grid;
      gap: 0.3rem;
    }

    .selectTop {
      display: flex;
      align-items: center;
      border: 1px solid #1f273a;
      box-sizing: border-box;
      border-radius: 6px;
      background-color: #1f273a;
      /* padding: 1rem; */
      justify-content: space-between;
      position: relative;
      box-sizing: border-box;

      select {
        font-family: "Inter";
        box-sizing: border-box;
        font-style: normal;
        font-weight: 600;
        outline: none;
        font-size: 16px;
        line-height: 19px;
        background-color: transparent;
        border: transparent;
        appearance: none;
        z-index: 10;
        width: 100%;
        color: #ffffff;
        padding: 1rem;
      }

      img {
        position: absolute;
        right: 0;
        padding: 1rem;
      }
    }

    .extra {
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      color: #ffffff;
    }

    .captions {
      display: flex;
      font-weight: 600;
      justify-content: space-between;

      .balance {
        font-size: 14px;
      }
    }
  }

  .addcon {
    display: grid;
    gap: 0.5rem;

    label {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #a3a3a3;
    }

    .add {
      outline: none;
      border: none;
      background: #1f273a;
      border-radius: 6px;
      width: 100%;
      /* border: 1px solid #3a4867; */

      input {
        display: flex;
        padding: 1rem;
        /* padding-right: 5px; */
        /* padding-left: 13px; */
        /* padding-top: 10px; */
        background-color: transparent;
        border: none;
        outline: none;
        box-sizing: border-box;
        min-width: 100%;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        color: #fff;
      }
    }
  }

  .amWrap {
    display: grid;
    gap: 0.5rem;

    label {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #a3a3a3;
    }

    .amBx {
      display: grid;
      gap: 0.3rem;
    }

    .amTop {
      display: flex;
      align-items: center;
      border: 1px solid #1f273a;
      box-sizing: border-box;
      border-radius: 6px;
      justify-content: space-between;

      .coinSelector {
        display: flex;
        background: #1f273a;
        border-radius: 4px;
        margin: 2px;
        padding: 0.7rem;
        align-items: center;
        gap: 0.5rem;
        width: 100px;
        place-content: center;

        p {
          font-weight: 500;
          font-size: 16px;
          line-height: 19px;
          color: #ffffff;
        }

        img {
          width: 16px;
        }
      }

      input {
        background-color: transparent;
        border: none;
        outline: none;
        width: 100%;
        height: 19px;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        color: #ffffff;
        padding-left: 1rem;
      }
    }

    .extra {
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      color: #ffffff;
    }

    .captions {
      display: flex;
      font-weight: 600;
      justify-content: space-between;

      .balance {
        font-size: 14px;
      }
    }
  }

  .box {
    border-radius: 4px;
    cursor: pointer;
  }

  .option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    color: #c9c9c9;

    img {
      width: 20px;
      height: auto;
    }
  }
`;

const ModalOption = styled.div``;

export default WithdrawalLimitModal;
